import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Svg, { Path } from '@dbk/ui-svg';
import { Small, H1 } from '@dbk/ui-text';
import Separator from '../../common/separator';
import { SeparatorFullWidth } from '../../common/separator/separator.styles';

class AppAdminHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
  }

  onLogout() {
    const { auth } = this.props;
    auth.onLogout();
  }

  render() {
    const {
      auth,
      i18n: { messages },
    } = this.props;
    return (
      <div className="margin-top-30">
        <div>
          <H1 secondary>{messages['app.common.marque.welcomeAdmin']}</H1>
        </div>
        <div className="row">
          <div className="small-10 columns">
            <Small secondary testID="text_userSession_adminHeader_test">
              {messages['app.profile.usersession']} {auth.lastSession} SGT/HKT
            </Small>
          </div>
          <div className="small-2 columns" onClick={() => this.onLogout()}>
            <a>{messages['app.common.profile.logOut']}</a>
          </div>
        </div>
        <div className="margin-top-10">
          <Separator separator={SeparatorFullWidth.separator} />
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      onLogout: { $call: 'logout' },
      lastSession: true,
    },
    i18n: {
      messages: true,
    },
  },
})(AppAdminHeader);
